import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase.ts";
import { type User } from "./userModel.ts";

interface Request {
  id: string;
}

interface Response {
  success: boolean;
  user: User;
}

export const swrKey = "admin_getUserById";

export const userFetcher = async ([_key, id]: [string, string]) => {
  const functions = getFirebaseFunctions();
  const getUserFunction = httpsCallable<Request, Response, object>(
    functions,
    swrKey,
  );
  const res = await getUserFunction({
    id,
  });
  return res.data.user;
};
